<template>
    <div class="page-loading" v-if="isLoading">
        <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
    </div>
    <div class="container-fluid">
        <header class="main-header main-header-container">
            <h1 class="main-title">Hyperlinks</h1>
            <button @click="addHyperlink()" type="button" class="btn btn-secondary">
                <font-awesome-icon :icon="['far', 'plus']" />
            </button>
        </header>

        <form @submit.prevent="updateHyperlinks()">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <ul class="list-group">
                            <li class="list-group-item list-group-item-disabled">
                                <div class="col">Naam</div>
                                <div class="col">Link</div>
                                <div class="col">Toon in menu</div>
                                <div class="col actions-column">Acties</div>
                            </li>
                            <li class="list-group-item" v-for="hyperlink in hyperlinks" :key="hyperlink.id">
                                <div class="col">{{ hyperlink.name }}</div>
                                <div class="col">{{ hyperlink.url }}</div>
                                <div class="col">
                                    <input type="checkbox" class="form-check-input secondary-checkbox"
                                        v-model="hyperlink.visibleInMenu"/>
                                </div>
                                <div class="col actions-column">
                                    <div class="hyperlink-actions">
                                    <button
                                        type="button"
                                        class="btn btn-danger action-button"
                                        @click="deleteHyperlink(hyperlink)"
                                        aria-label="Verwijder hyperlink"
                                    >
                                        <font-awesome-icon :icon="['fad', 'trash']" />
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-secondary action-button"
                                        @click="alterHyperlink(hyperlink.id)"
                                        aria-label="Wijzig hyperlink"
                                    >
                                        <font-awesome-icon :icon="['fad', 'pencil']" />
                                    </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="actions">
                    <button type="button" @click="getHyperlinks()" class="btn btn-gray">Annuleren</button>
                    <button type="submit" class="btn btn-primary-dark ms-3">Opslaan</button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: 'HyperlinksOverview',
    data() {
        return {
            isLoading: false,
            hyperlinks: [],
        };
    },
    mounted() {
        this.getHyperlinks();
    },
    methods: {
        getHyperlinks() {
            this.isLoading = true;
            this.$axiosInstance.get(`${process.env.VUE_APP_API}/hyperlink`)
                .then(response => {
                    this.hyperlinks = response.data;
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Hyperlinks konden niet opgehaald worden. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        deleteHyperlink(hyperlink) {
            const confirmed = window.confirm(`Weet je zeker dat je de hyperlink "${hyperlink.name}" wilt verwijderen?`);

            if (!confirmed) {
                return;
            }
            this.isLoading = true;
            this.$axiosInstance.delete(`${process.env.VUE_APP_API}/hyperlink/${hyperlink.id}`)
                .then(() => {
                    this.getHyperlinks();
                    this.$toast.open({
                        message: 'Hyperlink succesvol verwijderd.',
                        type: 'success',
                        position: 'top-right',
                        duration: 5000
                    });
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Hyperlink kon niet worden verwijderd. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        alterHyperlink(id) {
            this.$router.push(`/hyperlinks/${id}`);
        },
        addHyperlink() {
            this.$router.push('/hyperlinks/toevoegen');
        },
        updateHyperlinks() {
            this.isLoading = true;
            const response = this.$axiosInstance.put(`${process.env.VUE_APP_API}/hyperlink`, this.hyperlinks)
                .then(() => {
                    this.$toast.open({
                        message: 'Hyperlinks succesvol opgeslagen.',
                        type: 'success',
                        position: 'top-right',
                        duration: 5000
                    });
                this.hyperlink = response.data;
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Hyperlinks konden niet worden opgeslagen. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}

</script>



<style lang="scss" scoped>
.list-group-item {
    display: flex;
    align-items: center;

    .col {
        flex: 1;
    }

    .actions-column {
        display: flex;
        flex: 0 0 5.5rem;
        justify-content: flex-start;
        margin-left: auto;
    }

    .form-select {
        max-width: 10rem;
        margin-left: auto;
        border: 0;
        border-radius: 0;
    }
}

.list-group-item-disabled {
    background-color: #e9ecef;
    font-weight: bold;

    .form-select {
        background-color: #e9ecef;
    }
}

.actions {
    margin-top: $spacer * 1.5;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn {
        min-width: 7.5rem;
    }
}

.main-header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.hyperlink-actions {
    display: flex;
    align-items: center;
    gap: $spacer * 0.5;

    .action-button {
        width: 2.5rem;
        height: 2.5rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
    }
}
</style>
